export default "/shTOUCAN.94b8e9a77054803f4266d442ad133b9c.svg";